(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cgs-gift-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cgs-gifts')) return;

    const fmt = (cents, format) => {
      const n = Math.round(cents / 100);
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k.includes('comma') ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',')));
    };

    class CgsGifts extends HTMLElement {
      connectedCallback() {
        this.ship = +this.dataset.shipAt;
        this.giftAt = +this.dataset.giftAt;
        this.giftVariant = +this.dataset.giftVariant || 0;
        this.top = Math.max(this.ship, this.giftAt);
        this.refresh(); // display only: adding/removing the gift is done by snippets/cgs-gift-sync.liquid
        // the theme announces cart changes through @shopify/events; refresh once each change settles
        import('@shopify/events').then((ev) => {
          this.ev = ev;
          document.addEventListener(ev.StandardEvents.cartLinesUpdate, (e) => !this.ours && e.promise?.then(() => this.refresh(), () => {}));
        }).catch(() => {});
        window.addEventListener('pageshow', () => this.refresh());
      }

      async refresh() {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
        if (!cart) return;
        const sub = cart.items.reduce((s, i) => (i.variant_id === this.giftVariant ? s : s + i.final_line_price), 0);
        this.render(sub);
      }

      render(sub) {
        const fmtM = (c) => fmt(c, this.dataset.money);
        this.querySelectorAll('.cgs-gifts__item').forEach((el) => el.classList.toggle('is-open', sub >= +el.dataset.at));
        this.querySelector('.cgs-gifts__fill').style.width = `${Math.min(100, (sub / this.top) * 100)}%`;
        const next = [this.ship, this.giftAt].filter((a) => a > 0 && sub < a).sort((a, b) => a - b)[0];
        this.querySelector('[data-msg]').textContent = next ? this.dataset.msgMore.replace('{amount}', fmtM(next - sub)) : this.dataset.msgDone;
      }
    }

    customElements.define('cgs-gifts', CgsGifts);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cgs-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cgs-upsell')) return;

    const fmtMoney = (cents, format) => {
      const n = cents / 100;
      const group = (v, d, sep, dec) => {
        const [i, f = ''] = v.toFixed(d).split('.');
        return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? dec + f : '');
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        switch (k) {
          case 'amount_no_decimals': return group(n, 0, ',', '.');
          case 'amount_with_comma_separator': return group(n, 0, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
          default: return group(n, 0, ',', '.');
        }
      });
    };

    class CgsUpsell extends HTMLElement {
      connectedCallback() {
        this.money = this.dataset.money || '{{amount}}';
        this.fbtPct = +this.dataset.fbtPct || 0;
        const data = JSON.parse(this.querySelector('[data-prices]').textContent);
        this.prices = data.main;
        this.names = data.names;
        this.stock = data.stock || {};
        this.pairs = Array.isArray(data.pairs) ? data.pairs : [];
        this.errorBox = this.querySelector('[data-error-box]');
        this.addEventListener('change', (e) => this.onChange(e));
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-add-fbt]')) this.addFbt(e.target.closest('button'));
          else if (e.target.closest('[data-add-volume]')) this.addVolume(e.target.closest('button'));
        });
        // re-sync when the main variant changes; only while the block is near the viewport
        this.io = new IntersectionObserver((es) => es.some((x) => x.isIntersecting) && this.sync(), { rootMargin: '200px' });
        this.io.observe(this);
        // the theme's variant picker changes ?variant= after a fetch, so re-sync shortly after any change
        this.onPick = (e) => {
          if (this.contains(e.target) || !e.target.closest?.('variant-picker, product-form-component, form')) return;
          [250, 900].forEach((ms) => setTimeout(() => this.sync(), ms));
        };
        document.addEventListener('change', this.onPick);
        this.sync();
        this.stickyBar();
      }

      /** Bundle-only products have no theme Add to cart, so give the volume button a bar once it scrolls out of view. */
      stickyBar() {
        const btn = this.querySelector('[data-add-volume]');
        if (!btn || this.dataset.bundleOnly !== 'true') return;
        const bar = document.createElement('div');
        bar.className = 'cgs-sbar';
        bar.hidden = true;
        bar.innerHTML = '<span class="cgs-sbar__t"></span><button type="button" class="cgs-sbar__b"></button>';
        bar.querySelector('button').textContent = btn.textContent;
        bar.querySelector('button').addEventListener('click', () => btn.click());
        document.body.appendChild(bar);
        const label = () => {
          const t = this.querySelector('.cgs-tier.is-selected');
          bar.querySelector('.cgs-sbar__t').textContent = t ? `${t.querySelector('.cgs-tier__label').firstChild.textContent.trim()} · ${t.querySelector('[data-tier-price]').lastChild.textContent.trim()}` : '';
        };
        this.addEventListener('change', () => setTimeout(label, 0));
        label();
        // show only after the real button has scrolled above the viewport
        this.bio = new IntersectionObserver((es) => { bar.hidden = es[0].isIntersecting || es[0].boundingClientRect.top > 0; });
        this.bio.observe(btn);
        this.bar = bar;
      }

      disconnectedCallback() {
        this.io?.disconnect();
        this.bio?.disconnect();
        this.bar?.remove();
        document.removeEventListener('change', this.onPick);
      }

      /** Main variant is whatever the theme's buy box currently has selected. */
      mainVariantId() {
        const fromUrl = new URLSearchParams(location.search).get('variant');
        if (fromUrl && this.prices[fromUrl] !== undefined) return fromUrl;
        const input = [...document.querySelectorAll('form[action*="/cart/add"] [name="id"]')].find((el) => !this.contains(el));
        return input?.value || Object.keys(this.prices)[0];
      }

      mainPrice() {
        return this.prices[this.mainVariantId()] ?? 0;
      }

      onChange(e) {
        if (e.target.matches('[name^="cgs-vol"]')) {
          this.querySelectorAll('.cgs-tier').forEach((l) => l.classList.toggle('is-selected', l.contains(e.target)));
        }
        this.sync();
      }

      /** Same rule as the discount function (extensions/cgs-upsell-discount, pair loop): which ticked items get the bundle percent. */
      discounted(items) {
        const out = new Set();
        const unit = (l) => l.price;
        for (const pair of this.pairs) {
          const buys = new Set(pair.b.map(String));
          const gets = new Set(pair.g.map(String));
          const getLines = items.filter((l) => gets.has(l.product));
          const pureBuy = items.filter((l) => buys.has(l.product) && !gets.has(l.product)).length;
          const both = items.filter((l) => buys.has(l.product) && gets.has(l.product)).length;
          const pureGet = items.filter((l) => gets.has(l.product) && !buys.has(l.product)).length;
          if (!getLines.length || pureBuy + both === 0) continue;
          let sets = pureBuy, avail = pureGet + both, reserved = 0;
          while (reserved < both && Math.min(2 * (sets + 1), avail - 1) > Math.min(2 * sets, avail)) { sets++; avail--; reserved++; }
          let left = Math.min(2 * sets, avail);
          const taken = new Set([...getLines].filter((l) => buys.has(l.product)).sort((a, b) => unit(b) - unit(a)).slice(0, reserved));
          for (const l of [...getLines].filter((x) => !taken.has(x)).sort((a, b) => unit(a) - unit(b))) {
            if (left-- > 0) out.add(l);
          }
        }
        return out;
      }

      sync() {
        const main = this.mainPrice();
        const mp = this.querySelector('[data-main-price]');
        if (mp) mp.textContent = fmtMoney(main, this.money);
        const mv = this.querySelector('[data-main-variant]');
        if (mv) mv.textContent = this.names[this.mainVariantId()] || mv.textContent;

        // tiers above this variant's stock can't be bought; the base tier always stays
        const stock = this.stock[this.mainVariantId()];
        this.querySelectorAll('.cgs-tier').forEach((l, n) => {
          const i = l.querySelector('input');
          l.hidden = n > 0 && stock !== undefined && +i.dataset.qty > stock;
          if (l.hidden && i.checked) {
            const base = this.querySelector('.cgs-tier input');
            base.checked = true;
            base.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const q = +i.dataset.qty;
          const pct = +i.dataset.pct;
          const full = main * q;
          const total = Math.floor((full * (100 - pct)) / 10000 + 1e-6) * 100; // whole pounds, same as the discount function
          const pill = l.querySelector('[data-save]');
          if (pill) pill.innerHTML = `${this.dataset.saveLabel} ${fmtMoney(full - total, this.money)} <b>${pct}%</b>`;
          l.querySelector('[data-tier-price]').innerHTML = pct ? `<s>${fmtMoney(full, this.money)}</s>${fmtMoney(total, this.money)}` : fmtMoney(total, this.money);
        });

        // the discount only applies through this button, so say so and point at the next tier
        const nudge = this.querySelector('[data-nudge]');
        if (nudge) {
          const tiers = [...this.querySelectorAll('.cgs-tier:not([hidden]) input')];
          const on = tiers.findIndex((i) => i.checked);
          const next = tiers[on + 1];
          const ar = nudge.dataset.ar === '1';
          const tail = ar ? 'الخصم بيتطبق لما تضيف من الزرار ده.' : 'Discount applies when you add with this button.';
          const lead = next ? (ar ? `اختار ${next.dataset.qty} قطعة ووفر ${next.dataset.pct}%. ` : `Pick ${next.dataset.qty} and save ${next.dataset.pct}%. `) : '';
          nudge.textContent = tiers.length > 1 ? lead + tail : '';
          nudge.hidden = tiers.length < 2;
        }

        const t = this.querySelector('[data-fbt-total]');
        if (!t) return;
        const lis = [...this.querySelectorAll('[data-companion]')];
        const priceOf = (li) => {
          const v = li.querySelector('[data-variant]');
          return v.matches('select') ? +v.selectedOptions[0].dataset.price : +v.dataset.price;
        };
        const mainItem = { product: this.dataset.productId, price: main };
        const items = lis.filter((li) => li.querySelector('[data-check]').checked).map((li) => ({ li, product: li.dataset.product, price: priceOf(li) }));
        const off = this.discounted([mainItem, ...items]);
        const cut = (it) => (this.fbtPct && off.has(it) ? it.price - Math.floor((it.price * (100 - this.fbtPct)) / 10000 + 1e-6) * 100 : 0);
        const mainCut = cut(mainItem);
        if (mp) mp.textContent = fmtMoney(main - mainCut, this.money);
        const mw = this.querySelector('[data-main-was]');
        mw.hidden = !mainCut;
        mw.textContent = mainCut ? fmtMoney(main, this.money) : '';
        let sum = main - mainCut;
        let save = mainCut;
        lis.forEach((li) => {
          const it = items.find((x) => x.li === li);
          const price = priceOf(li);
          const d = it ? cut(it) : 0;
          li.querySelector('[data-price-label]').textContent = fmtMoney(price - d, this.money);
          const w = li.querySelector('[data-was]');
          w.hidden = !d;
          w.textContent = d ? fmtMoney(price, this.money) : '';
          li.querySelector('[data-chip]').hidden = !d;
          if (it) { sum += price - d; save += d; }
        });
        t.textContent = fmtMoney(sum, this.money);
        const was = this.querySelector('[data-fbt-was]');
        const saved = this.querySelector('[data-fbt-saved]');
        was.hidden = saved.hidden = !save;
        if (save) {
          was.textContent = fmtMoney(sum + save, this.money);
          saved.textContent = `${this.dataset.savedLabel} ${fmtMoney(save, this.money)}`;
        }
      }

      fbtItems() {
        const items = [{ id: +this.mainVariantId() }];
        this.querySelectorAll('[data-companion]').forEach((li) => {
          if (!li.querySelector('[data-check]').checked) return;
          items.push({ id: +li.querySelector('[data-variant]').value });
        });
        return items;
      }

      addVolume(btn) {
        const qty = +(this.querySelector('[name^="cgs-vol"]:checked')?.dataset.qty || 1);
        return this.add(btn, [{ id: +this.mainVariantId(), quantity: qty, properties: { _cgs_upsell: 'volume', _cgs_max: `${qty}:${Date.now()}` } }]);
      }

      addFbt(btn) {
        const items = this.fbtItems();
        const stamp = Date.now();
        // _cgs_bundle is shared by every item added together; the discount needs all of them in the cart
        return this.add(btn, items.map((it) => ({ id: it.id, quantity: 1, properties: { _cgs_upsell: 'fbt', _cgs_max: `1:${stamp}`, _cgs_bundle: `${stamp}:${items.length}` } })));
      }

      /** Posts to /cart/add.js and tells the theme's cart (drawer, count) via its own event. */
      async add(btn, items) {
        this.errorBox.hidden = true;
        btn.disabled = true;
        let deferred;
        try {
          const events = await import('@shopify/events').catch(() => null);
          const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((c) => c.dataset.sectionId);
          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new events.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
              promise: deferred.promise,
            }));
          }
          const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, ...(sections.length && { sections: sections.join(',') }) }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
          const cart = await fetch((window.Theme?.routes?.cart_url || '/cart') + '.json', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          if (events) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'cgs-upsell', sourceId: this.id, itemCount: items.reduce((s, i) => s + i.quantity, 0), productId: this.dataset.productId, sections: data.sections, didError: false },
            });
          } else {
            location.href = window.Theme?.routes?.cart_url || '/cart';
          }
        } catch (err) {
          deferred?.reject(err);
          this.errorBox.textContent = err.message && err.message !== 'add failed' ? err.message : this.dataset.error;
          this.errorBox.hidden = false;
        } finally {
          btn.disabled = false;
        }
      }
    }

    customElements.define('cgs-upsell', CgsUpsell);
  })();
  } catch(e) { console.error(e); }
})();

})();
